import { Click } from '../actions'
import { Tile, type TileProperties } from '../objects/Tile'
import { analytics } from './lib'

export const tileClick = (properties: TileProperties) => {
  return analytics(new Click(), new Tile(properties))
}
